// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>5</span>&nbsp;&nbsp;Such knowledge is too wonderful for me,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;so high that I cannot attain it.<br> </p> </div></div>";
// Exports
module.exports = code;